import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToStorefrontTarget, StorefrontNavigationState } from "@/lib/storefrontNavigation";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    const state = (location.state ?? null) as StorefrontNavigationState | null;

    if (state?.scrollTarget) {
      scrollToStorefrontTarget(state.scrollTarget);
      return;
    }

    if (location.hash) {
      scrollToStorefrontTarget(location.hash.slice(1));
      return;
    }

    if (state?.scrollToTop || !location.hash) {
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }, [location]);

  return null;
};

export default ScrollToTop;
